import store from "@/store";
import axios from "axios";

store.subscribe((mutation) => {
  // console.log('mutaion', mutation)
  if (mutation.type) {
    axios.defaults.baseURL = "https://toolkitapi-staging.armpension.com/api/";
    axios.defaults.headers["Authorization"] = `Bearer ${localStorage.getItem(
      "token"
    )}`;
    axios.defaults.headers["Employer"] = store.state.getLoggedInUser?.code;
    axios.defaults.headers["Contact"] =
      store.state.getLoggedInUser?.contact_code;
  }
});
